export enum CreditorGroupAuthInfoOverrideLeval {
    ALL_CREDITORS_IN_CREDITOR_GROUP = 0,
    ONLY_APPLICABLE_CREDITORS_IN_CREDITOR_GROUP = 1,
  }
export enum CreditorAuthInfoEntityType {
  CREDITOR_GROUP = "CG",
}

export type AddCreditorAuthorizedInformation = {
  entityId: number;
  entityType: string;
  creditorAuthorizedInformation: string;
  overrideLevel: number;

}